import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputChecbox from "../../helpers/InputCheckbox";
import InputCombo from "../../helpers/InputCombo";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputInteger from "../../helpers/InputInteger";
import InputPassword from "../../helpers/InputPassword";




function OnlineForm(props)
{

    const [row, setRow] = useState({
              id: -1,
              username: '',
              password: '',
              pr: [],
    })
    var tmpRow = row;



    const valChangeListener = (filedName, val, correct, msg) => {   
        
              
        
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];

                   

                    if(correct)tRef[tabInx]['stan'] = val;
                    if(!correct)tRef[tabInx]['stan'] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         

 
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
             
            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_home,user_online_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                props.onSuccess(res.result);  //przekaz id Firmy 
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }
    

const getDet = () => {
        

      
        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_home,user_online_det', {
            method: 'POST', 
            body: JSON.stringify({
                id: props.id
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                                                                    
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }




     const keyListener = (e) => {

                        var code = e.keyCode ? e.keyCode : e.which;    
                        console.log("keylockd", e.target.nodeName, code );

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                                           
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else 
                        if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();                          
                                       e.preventDefault();
                        } else 
                        {
                            props.keyListener(e);
                        }

     }


        useEffect(() => {
        
            if(row.id != props.id)
            {
                getDet();
            }
                             
                if(Config.env == "dev") console.log("OnlineForm.js, listener on");
                window.onkeydown =  keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("OnlineForm.js, listener off");      
                    window.onkeydown =  props.keyListener;
                };

      });
   



   return <div className="view_content">
                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>    

                        <form className="eForm bg_center">

                                 <div className="form_tab_title">Autoryzacja:</div>
                                 <div className="form_tab">

                                                        <div className="form_control">
                                                                <div className="fieldName">Username / e-mail*</div>
                                                                <InputText   userData={props.userData} value={row.username} err={null}  valChange={valChangeListener} goNext={goNextNew} name="username" placeholder={"Username / e-mail"} className=' w300 ' req='0' firstUp="0" />
                                                        </div>

                                                        <div className="form_split"></div>

                                                         <div className="form_control">
                                                                <div className="fieldName">Hasło*</div>
                                                                <InputPassword   userData={props.userData} value={row.password} err={null}  valChange={valChangeListener} goNext={goNextNew} name="password" placeholder={"Hasło"} className=' w300 ' req='0' firstUp="0" />
                                                        </div>
                                    </div>

                                      <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                </div>

                                    <div className="form_tab_title">Autoryzacja</div>
                                    <div className="form_tab scroll200">

                                            {
                                                row.pr.map(  (item, ix) => {
                                                    return <Fragment>

                                                          <div className="form_control form_filed_inline">                                                             
                                                              
                                                                <InputCombo items={ [ {v:'0',title:'Nie'}, {v:'1',title:'Tak'},   ]   }  userData={props.userData} value={item.stan} err={null}  valChange={valChangeListener} valChangeListener={valChangeListener} name={"pr@"+ix} placeholder={""} className='   ' req='0' firstUp="0" />                                                              
                                                                {item.nazwa}, {item.description}  
                                                          </div>

                                                          <br/>

                                                    </Fragment>
                                                } )
                                            }

                                    </div>

                                      <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                </div>


                        </form>
    </div>
}


export default OnlineForm;